import { mapGetters } from "vuex";
import {determineAGAttributes} from '../settings';

export default {
    data() {
        return {

        }
    },

    computed: {
        ...mapGetters([
            'activeProductKey',
            'activeOfferKey'
        ]),

        ...mapGetters('content', [
            'webstoreContent'
        ]),

        mmyData() {
            return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/mmyData`];
        },

        vinData() {
            return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/vinData`];
        },

        manualSelectionData() {
            return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/manualSelection/manualSelectionData`];
        },

        submittedMMYData() {
            return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/mmy/submittedMMYData`];
        },

        submittedVinData() {
            return this.$store.getters[`${this.activeProductKey}${this.activeOfferKey}CableSelection/vin/submittedVinData`];
        },
    },

    methods: {
        isRowEmpty(mmyRow) {
            return Object.values(mmyRow).every((val) => !val);
        },

        isRowComplete(mmyRow) {
            return Object.values(mmyRow).every((val) => val);
        },

        isMMYRowPartiallyFilled: function(mmyRow) {
            if (this.activeProductKey === "AG26" || this.activeProductKey === "AG-CBL") {
                let cleanMmyRow = this.cleanAGMmyRow(mmyRow)
                return !this.isRowComplete(cleanMmyRow) && !this.isRowEmpty(cleanMmyRow);
            }
            return !this.isRowComplete(mmyRow) && !this.isRowEmpty(mmyRow);
        },

        areMMYRowsCompleted: function() {
            return this.mmyData.every(mmyRow => !this.isMMYRowPartiallyFilled(mmyRow));
        },

        areMMYRowsCompleteSpecific: function () {
            let badRows = [];
            this.mmyData.forEach((mmyRow, index) => {
                if (this.isMMYRowPartiallyFilled(mmyRow)) {
                    badRows.push(index);
                }
            });
            return badRows;
        },

        isAtleastOneRowCompleted() {
            if (this.activeProductKey === "AG26") {
                return this.mmyData.some(mmyRow => this.isRowComplete(this.cleanAGMmyRow(mmyRow)));
            }
            return this.mmyData.some(mmyRow => this.isRowComplete(mmyRow));
        },

        fireIncompleteMMYAlert: function() {
            this.$fire({
                title: this.webstoreContent.webstoreAlerts.mmy_input_incomplete.title,
                text: this.webstoreContent.webstoreAlerts.mmy_input_incomplete.text,
                type: "error"
            });
        },

        cleanAGMmyRow(mmyRow) {
            let listOfActiveAGInputs = determineAGAttributes(mmyRow);
            let cleanMmyRow = {...mmyRow};
            for (let input in cleanMmyRow) {
                if (!listOfActiveAGInputs.includes(input) && input !== "quantity") {
                    delete cleanMmyRow[input];
                }
            }
            return cleanMmyRow;
        },

        calculateMaxCableSubmissionQuantity(selectionType) {
            let mmyData = selectionType === "mmy" ? this.mmyData : null;
            let vinData = selectionType === "vin" ? this.vinData : null;
            let manualSelectionData = selectionType === "plug type" ? this.manualSelectionData : null;
            let vinCount = 0
            let mmyCount = 0;
            let manualSelectionCount = 0;

            if (mmyData) {
                mmyCount = Object.values(mmyData).reduce((prev,next) => prev + next.quantity, 0);
            }

            if (manualSelectionData) {
                manualSelectionCount = Object.values(manualSelectionData).reduce((prev, next) => prev + next, 0)
            }

            if (vinData && vinData.length > 0) {
                vinCount = typeof vinData === "string" ? vinData.split('\n').filter(vin => vin).length : vinData.reduce((prev,next) => prev + next.quantity, 0);
            }
            return mmyCount + manualSelectionCount + vinCount
        },

        fireIncorrectCablesSelectedCountAlert: function(cablesSelectedCount, cablesNeededCount) {
            this.$fire({
                title: this.webstoreContent.webstoreAlerts.incorrect_number_of_cables_selected.title,
                text: this.webstoreContent.webstoreAlerts.incorrect_number_of_cables_selected.text.replace("cables_selected_count", cablesSelectedCount).replace("cables_needed_count", cablesNeededCount),
                type: "error"
            });
        },
    }
}